import { Field } from '@micin-jp/chicken-schema'

import {
  CheckboxFieldValue,
  FieldValue,
  RadioFieldValue,
  SelectMenuFieldValue,
} from '../../types'
import { FlattenFieldMap } from '../../utils/getFlattenFields'

type ChoiceFieldValue =
  CheckboxFieldValue | RadioFieldValue | SelectMenuFieldValue

/**
 * 選択肢フィールドかどうかを判定
 */
const isChoiceFieldValue = (
  fieldValue: FieldValue,
): fieldValue is ChoiceFieldValue => {
  return ['checkbox', 'radio', 'selectMenu'].includes(fieldValue.type)
}

/**
 * 指定されたcidが選択されているかどうかをチェック
 */
const isChoiceSelected = (
  fieldValue: ChoiceFieldValue,
  cid: string,
): boolean => {
  switch (fieldValue.type) {
    case 'checkbox':
      return fieldValue.checkboxValue.includes(cid)
    case 'radio':
      return fieldValue.radioValue === cid
    case 'selectMenu':
      return fieldValue.selectMenuValue === cid
  }
}

/**
 * visibleIf条件をチェックして表示するかどうかを判定
 * @param field チェック対象のフィールド
 * @param fieldValues 全フィールドの値
 * @param fieldMap フィールドマップ
 * @param index フィールドのindex（リピータブルセクション外の場合は1）
 */
export const checkVisibleIf = (
  field: Field,
  fieldValues: FieldValue[],
  fieldMap: FlattenFieldMap,
  index: number = 1,
): boolean => {
  // visibleIfがない場合は常に表示
  if (!field.visibleIf) return true

  const { operand, fid, cid } = field.visibleIf
  if (operand !== 'hasChoice') return true

  // 親フィールドの値を取得
  // リピータブルセクション内のフィールドの場合は同じindexで検索
  // セクション外のフィールド（リピータブルセクション自体など）の場合はindex=1で検索
  const parentFieldValue = fieldValues.find(
    fv => fv.fid === fid && fv.index === index,
  )
  if (!parentFieldValue) return false

  // 選択肢フィールドでない場合は非表示
  if (!isChoiceFieldValue(parentFieldValue)) return false

  // cidが選択されているかチェック
  if (!isChoiceSelected(parentFieldValue, cid)) return false

  // 親フィールド自体もvisibleIfを持つ場合は再帰的にチェック
  const parentField = fieldMap.get(fid)
  if (parentField) {
    return checkVisibleIf(parentField, fieldValues, fieldMap, index)
  }

  return true
}
